import {
  SHOW_CLOSEABLE_ISSUES_WARNING_MODAL,
  CLOSE_CLOSEABLE_ISSUES_WARNING_MODAL,
  SHOW_SIDEBAR,
  CLOSE_SIDEBAR,
  TOGGLE_SIDEBAR_FILTER
} from './actions.js'

const initialState = {
  closeableIssuesWarningModal: {
    open: false,
    carePlanIds: []
  },
  sidebar: {
    open: false,
    filters: {
      'in-progress': true,
      'not-started': true
    }
  }
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case SHOW_CLOSEABLE_ISSUES_WARNING_MODAL:
      return {
        ...state,
        closeableIssuesWarningModal: {
          open: true,
          carePlanIds: action.carePlanIds
        }
      }
    case CLOSE_CLOSEABLE_ISSUES_WARNING_MODAL:
      return {
        ...state,
        closeableIssuesWarningModal: {
          open: false,
          carePlanIds: []
        }
      }
    case SHOW_SIDEBAR:
      return {
        ...state,
        sidebar: {
          ...state.sidebar,
          open: true
        }
      }
    case CLOSE_SIDEBAR:
      return {
        ...state,
        sidebar: {
          ...state.sidebar,
          open: false
        }
      }
    case TOGGLE_SIDEBAR_FILTER:
      return {
        ...state,
        sidebar: {
          ...state.sidebar,
          filters: {
            ...state.sidebar.filters,
            [action.filter]: !state.sidebar.filters[action.filter]
          }
        }
      }
    default:
      return state
  }
}
